import { common } from '@mui/material/colors';
import BaseTextField from 'common/components/base-text-field';
import React from 'react';
interface Props {
    name: string;
}
const QuestionNumber: React.FC<Props> = ({ name }) => {
    return (
        <BaseTextField
            name={name}
            placeholder="Vui lòng nhập số"
            fullWidth={true}
            autoComplete="off"
            InputProps={{
                inputProps: {
                    maxLength: 55,
                },
            }}
            sx={{
                '& .MuiInputBase-root': {
                    height: ['3.5rem', '3.5rem', '4rem', '5rem', '5rem'],
                    fontSize: ['1rem', '1rem', '1.5rem', '1.5rem', '1.5rem'],
                    backgroundColor: common.white,
                    borderRadius: '10px',
                },
            }}
        />
    );
};

export default QuestionNumber;
